import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Box,
} from "@mui/material";

import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useNavigate } from 'react-router-dom';

const ModalCancelarAssinatura = (props) => {

    const navigate = useNavigate();

    const handleClose = () => {
        props.setOpenModalCancelarAssinatura(false);
    };

    const handleAgree = () => {
        navigate('/CancelarAssinatura');
        props.setOpenModalCancelarAssinatura(false);
    }
    return (
        <>
            <Dialog
                open={props.openModalCancelarAssinatura}
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ pb: 1 }}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                        }}
                    >
                        <Box
                            sx={{
                                width: 45,
                                height: 45,
                                borderRadius: "12px",
                                bgcolor: "#FEECEC",
                                color: "#E53935",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <WarningAmberRoundedIcon />
                        </Box>

                        <Box>
                            <Typography
                                variant="h6"
                                fontWeight={700}
                            >
                                Cancelar Assinatura
                            </Typography>

                            <Typography
                                variant="body2"
                                color="text.secondary"
                            >
                                Esta ação requer confirmação.
                            </Typography>
                        </Box>
                    </Box>
                </DialogTitle>

                <DialogContent>
                    <Box
                        sx={{
                            mt: 1,
                            p: 2,
                            borderRadius: "12px",
                            bgcolor: "#FFF5F5",
                            border: "1px solid #FFD6D6",
                        }}
                    >
                        <Typography
                            variant="body1"
                            sx={{ mb: 2 }}
                        >
                            Tem certeza que deseja cancelar sua assinatura?
                        </Typography>

                        <Typography
                            variant="body2"
                            color="text.secondary"
                        >
                            Ao cancelar, você continuará com acesso ao plano
                            até o final do ciclo atual. Após essa data:
                        </Typography>

                        <Box
                            component="ul"
                            sx={{
                                mt: 2,
                                mb: 0,
                                pl: 3,
                                color: "#555",
                            }}
                        >
                            <li>Perderá acesso às funcionalidades premium.</li>
                            <li>As automações serão interrompidas.</li>
                            <li>Novas cobranças não serão realizadas.</li>
                        </Box>
                    </Box>
                </DialogContent>

                <DialogActions
                    sx={{
                        p: 3,
                        pt: 1,
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 2,
                    }}
                >
                    <Button
                        variant="contained"
                        color="success"
                        onClick={handleClose}
                        sx={{
                            borderRadius: "12px",
                            px: 3,
                            fontWeight: 700,
                            textTransform: "none",
                        }}
                    >
                        Manter Assinatura
                    </Button>

                    <Button
                        variant="outlined"
                        color="error"
                        startIcon={<CloseRoundedIcon />}
                        onClick={handleAgree}
                        sx={{
                            borderRadius: "12px",
                            px: 3,
                            fontWeight: 700,
                            textTransform: "none",
                        }}
                    >
                        Confirmar Cancelamento
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default ModalCancelarAssinatura;